export const PRIME_NEW_TIMEOUT_POPUP = "PRIME_PRIMO53D";
export const EQUAL_PROMINENCE_MOBILE = "PRIME_PRIMO70M";

export const primoAliases = {
  primeNewTimeoutPopup: PRIME_NEW_TIMEOUT_POPUP,
  equalProminenceMobile: EQUAL_PROMINENCE_MOBILE,
};

export const aliases = Object.values(primoAliases);
